import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { DivisionSummaryReportSchemaObject } from '../DivisionSummaryReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import moment from 'moment';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import ReactToPrint from "react-to-print";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import CreatePdf from './createPdf';
import MessageModal from '../../../../UI/Modal/MessageModal';
import { InputAdornment, Box } from '@material-ui/core';
import Search from '@mui/icons-material/Search';

const screenCode = "WORKERCAPTUREAUDITREPORT";
const modeOptions = {
    "0": "Default",
    "1": "FaceID",
    "3": "QR",
    "6": "Manual"
};

const typeOptions = {
    "General": "General",
    "RSM": "RSM",
    "Cash": "Cash",
    "Kilo": "Kilo"
};

const sessionColumns = [
    { id: 1, label: "Session 01", keys: ["session01", "session1", "firstSession"] },
    { id: 2, label: "Session 02", keys: ["session02", "session2", "secondSession"] },
    { id: 3, label: "Session 03", keys: ["session03", "session3", "thirdSession"] }
];

const captureModeColumns = [
    { id: 6, label: "Manual", keys: ["manual", "manualReg", "manualWeight", "manualQty", "manualAmount"] },
    { id: 3, label: "QR", keys: ["qr", "qrCard", "qrWeight", "qrQty", "qrAmount"] },
    { id: 1, label: "Face ID", keys: ["faceID", "faceId", "face", "faceWeight", "faceIDWeight"] }
];

const dateRangeErrorMessage = "To Date should be greater than or equal to From Date";
const fromDateFutureErrorMessage = "From Date cannot be a future date";

function getCurrentDate() {
    const today = new Date();
    const month = `${today.getMonth() + 1}`.padStart(2, "0");
    const day = `${today.getDate()}`.padStart(2, "0");

    return `${today.getFullYear()}-${month}-${day}`;
}

export function WorkerCaptureAuditReport(props) {

    const componentRef = useRef();
    const currentDate = getCurrentDate();
    const [divisions, setDivisions] = useState([]);
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        description: "",
    });
    const [reportData, setReportData] = useState([]);
    const [reportSearchDetails, setReportSearchDetails] = useState(null);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [integrationDetails, setDivisionSummaryDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        modeID: "0",
        typeID: "0",
        toDate: currentDate,
        fromDate: currentDate
    });

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });
    const [searchText, setSearchText] = useState("");

    const schema = Joi.object(DivisionSummaryReportSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(getEstatesForDropdown())
    }, [integrationDetails.groupID])

    useEffect(() => {
        trackPromise(getDivisionsForDropDown())
    }, [integrationDetails.estateID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWWORKERCAPTUREAUDITREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();
        setDivisionSummaryDetails({
            ...integrationDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(integrationDetails.groupID);
        const token = tokenService.getUserDetailsFromTokenV2();
        const validEstateIds = token.operationEntities.map(entity => String(entity.OperationEntityID));

        const estateList = data
            .map((name, index) => name ? { id: String(index), name } : null)
            .filter(item => item !== null);

        const filteredEstates = estateList.filter(estate =>
            validEstateIds.includes(String(estate.id))
        );

        const filteredEstateArray = [];
        filteredEstates.forEach(estate => {
            filteredEstateArray[parseInt(estate.id)] = estate.name;
        });

        setMultipleEstates(filteredEstateArray);
        setEstates(filteredEstateArray);
    }


    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(integrationDetails.estateID);
        setDivisions(data);
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, integrationDetails);
        const validationErrors = errorMessages !== null ? { ...errorMessages } : {};
        const dateRangeError = getDateRangeError(integrationDetails);
        const fromDateFutureError = getFromDateFutureError(integrationDetails);

        if (fromDateFutureError) {
            validationErrors.fromDate = fromDateFutureError;
        }
        if (dateRangeError) {
            validationErrors.toDate = dateRangeError;
        }

        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) return;

        const result = await services.getIntegrationReportData(integrationDetails);
        const reportResult = Array.isArray(result) ? result : [];

        if (reportResult.length === 0) {
            setReportData([]);
            setReportSearchDetails(null);
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                description: "No records found."
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
            return;
        }

        setReportData(reportResult);
        setSearchText("");
        setReportSearchDetails(getReportSearchDetails(integrationDetails));
    }

    function handleChange(target) {
        validateInputs(target);

        let updatedDetails = {
            ...integrationDetails,
            [target.name]: target.value,
        };

        if (target.name === "groupID") {
            updatedDetails = {
                ...updatedDetails,
                estateID: "0",
                divisionID: "0"
            };
        }

        if (target.name === "estateID") {
            updatedDetails = {
                ...updatedDetails,
                divisionID: "0",
                modeID: "0",
                typeID: "0",
                fromDate: getCurrentDate(),
                toDate: getCurrentDate()
            };
        }

        if (target.name === "divisionID") {
            const currentDate = getCurrentDate();
            updatedDetails = {
                ...updatedDetails,
                fromDate: currentDate,
                toDate: currentDate
            };
        }

        setDivisionSummaryDetails(updatedDetails);
        setReportData([]);
        setReportSearchDetails(null);

        if (target.name === "fromDate" || target.name === "toDate") {
            const dateRangeError = getDateRangeError(updatedDetails);
            const fromDateFutureError = getFromDateFutureError(updatedDetails);
            setErrors(previousErrors => {
                const updatedErrors = { ...previousErrors };

                if (fromDateFutureError) {
                    updatedErrors.fromDate = fromDateFutureError;
                } else if (updatedErrors.fromDate === fromDateFutureErrorMessage) {
                    delete updatedErrors.fromDate;
                }

                if (dateRangeError) {
                    updatedErrors.toDate = dateRangeError;
                } else if (updatedErrors.toDate === dateRangeErrorMessage) {
                    delete updatedErrors.toDate;
                }

                return updatedErrors;
            });
        }
    }

    function validateInputs(target) {
        const error = { ...errors };
        delete error.noRecords;

        const errorMessage = validateProperty(target, DivisionSummaryReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setDivisionSummaryDetails({
            ...integrationDetails,
            divisionID: "0",
            modeID: "0",
            typeID: "0",
            toDate: getCurrentDate(),
            fromDate: getCurrentDate()
        });
        setErrors({});
        setReportData([]);
        setReportSearchDetails(null);
        setSearchText("");
    }

    function getReportSearchDetails(searchForm) {
        return {
            group: groups[searchForm.groupID] || "-",
            estate: estates[searchForm.estateID] || "-",
            division: getDivisionName(searchForm.divisionID),
            mode: getModeName(searchForm.modeID),
            type: getTypeName(searchForm.typeID),
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        };
    }

    function getModeName(modeID) {
        return modeID == "0" || modeOptions[modeID] == undefined ? "All" : modeOptions[modeID];
    }

    function getTypeName(typeID) {
        return typeOptions[typeID] == undefined ? "All" : typeOptions[typeID];
    }

    function getDivisionName(divisionID) {
        return divisionID == "0" || divisions[divisionID] == undefined ? "All" : divisions[divisionID];
    }

    function getDateRangeError(searchForm) {
        if (searchForm.fromDate && searchForm.toDate && moment(searchForm.toDate).isBefore(moment(searchForm.fromDate), 'day')) {
            return dateRangeErrorMessage;
        }

        return null;
    }

    function getFromDateFutureError(searchForm) {
        if (searchForm.fromDate && moment(searchForm.fromDate).isAfter(moment(getCurrentDate()), 'day')) {
            return fromDateFutureErrorMessage;
        }

        return null;
    }

    function getDisplayValue(row, fieldNames) {
        const value = fieldNames.map(fieldName => row[fieldName]).find(fieldValue => fieldValue !== undefined && fieldValue !== null && fieldValue !== "");
        return value === undefined ? "-" : value;
    }

    function getRawValue(row, fieldNames) {
        const exactValue = fieldNames.map(fieldName => row[fieldName]).find(fieldValue => fieldValue !== undefined && fieldValue !== null && fieldValue !== "");
        if (exactValue !== undefined) {
            return exactValue;
        }

        const rowKeys = Object.keys(row);
        const matchedKey = fieldNames
            .map(fieldName => normalizeText(fieldName))
            .map(fieldName => rowKeys.find(rowKey => normalizeText(rowKey) === fieldName))
            .find(rowKey => rowKey !== undefined);

        return matchedKey === undefined ? undefined : row[matchedKey];
    }

    function getRowDate(row) {
        const value = getDisplayValue(row, ["date", "collectionDate", "pluckingDate", "workDate", "createdDate"]);
        return value == "-" ? "-" : moment(value).format("YYYY-MM-DD");
    }

    function getRowTime(row) {
        const value = getDisplayValue(row, ["time", "collectionTime", "pluckingTime", "createdTime", "createdDate"]);
        if (typeof value === "string" && value.includes(":") && !value.includes("-") && !value.includes("T")) {
            return value;
        }

        return value == "-" ? "-" : moment(value).format("HH:mm");
    }

    function normalizeText(value) {
        return value === undefined || value === null ? "" : value.toString().toLowerCase().replace(/[\s_-]/g, "");
    }

    function getRowSessionID(row) {
        const sessionID = getRawValue(row, ["sessionID", "sessionId", "mobileSessionID", "mobileSessionId", "sessionNo", "sessionNumber"]);
        const parsedSessionID = parseInt(sessionID);
        if (!isNaN(parsedSessionID)) {
            return parsedSessionID;
        }

        const sessionName = normalizeText(getRawValue(row, ["sessionName", "session"]));
        const matchedSession = sessionColumns.find(session =>
            sessionName === normalizeText(session.label) ||
            session.keys.some(key => sessionName === normalizeText(key))
        );

        return matchedSession === undefined ? null : matchedSession.id;
    }

    function getRowCaptureModeID(row) {
        const modeID = getRawValue(row, ["modeID", "modeId", "captureModeID", "captureModeId", "captureMode"]);
        const parsedModeID = parseInt(modeID);
        if (!isNaN(parsedModeID)) {
            return parsedModeID;
        }

        const modeName = normalizeText(getRawValue(row, ["mode", "modeName", "captureModeName"]));
        const matchedMode = captureModeColumns.find(mode =>
            modeName === normalizeText(mode.label) ||
            mode.keys.some(key => modeName === normalizeText(key))
        );

        return matchedMode === undefined ? null : matchedMode.id;
    }

    function formatCaptureEntry(row, value) {
        if (value === undefined || value === null || value === "") {
            return null;
        }
        const kg = typeof value === "string" && value.toLowerCase().includes("kg")
            ? value
            : `${value} Kg`;
        const narration = (row.narration || row.Narration || "").toString().trim();
        return { kg, narration };
    }

    function getDirectSessionValue(row, session, mode) {
        const fieldNames = [];

        session.keys.forEach(sessionKey => {
            mode.keys.forEach(modeKey => {
                fieldNames.push(`${sessionKey}${modeKey}`);
                fieldNames.push(`${sessionKey}${modeKey.charAt(0).toUpperCase()}${modeKey.slice(1)}`);
            });
        });

        return getRawValue(row, fieldNames);
    }

    function getCaptureAmount(row) {
        return getRawValue(row, ["weightInKg", "weightKg", "amount", "totalAmount", "quantity", "qty", "weight", "totalWeight", "leafWeight", "greenLeafWeight"]);
    }

    function getSessionCaptureValue(row, session, mode) {
        const directValue = getDirectSessionValue(row, session, mode);
        if (directValue !== undefined) {
            return formatCaptureEntry(row, directValue);
        }
        if (getRowSessionID(row) === session.id && getRowCaptureModeID(row) === mode.id) {
            return formatCaptureEntry(row, getCaptureAmount(row));
        }
        return null;
    }

    function getCapturePercentages(data) {
        return sessionColumns.reduce((sessionTotals, session) => {
            const modeCounts = {};
            let sessionTotal = 0;

            captureModeColumns.forEach(mode => {
                modeCounts[mode.id] = data.filter(row => getSessionCaptureValue(row, session, mode) !== null).length;
                sessionTotal += modeCounts[mode.id];
            });

            sessionTotals[session.id] = captureModeColumns.reduce((percentageTotals, mode) => {
                percentageTotals[mode.id] = sessionTotal === 0 ? "0%" : `${Math.round((modeCounts[mode.id] / sessionTotal) * 100)}%`;
                return percentageTotals;
            }, {});

            return sessionTotals;
        }, {});
    }

    function groupReportData(data) {
        const grouped = {};

        data.forEach(row => {
            const key = [
                getRowDate(row),
                getRowTime(row),
                getDisplayValue(row, ["empNo", "employeeNumber", "registrationNumber", "empCode"]),
                getDisplayValue(row, ["empName", "employeeName", "firstName", "name"]),
                getDisplayValue(row, ["workedDivision", "workedDivisionName", "collectionPointName", "divisionName"]),
                getDisplayValue(row, ["field", "fieldName", "blockName"]),
                getDisplayValue(row, ["operator", "operatorName", "userName", "createdByName", "createdBy"])
            ].join("|");

            if (!grouped[key]) {
                grouped[key] = [];
            }
            grouped[key].push(row);
        });

        return Object.values(grouped);
    }

    function filterReportData(data, text) {
        if (!text.trim()) return data;
        const lower = text.trim().toLowerCase();
        return data.filter(row => {
            const searchableValues = [
                getDisplayValue(row, ["empNo", "employeeNumber", "registrationNumber", "empCode"]),
                getDisplayValue(row, ["empName", "employeeName", "firstName", "name"]),
                getDisplayValue(row, ["workedDivision", "workedDivisionName", "collectionPointName", "divisionName"]),
                getDisplayValue(row, ["field", "fieldName", "blockName"]),
                getDisplayValue(row, ["operator", "operatorName", "userName", "createdByName", "createdBy"])
            ];
            return searchableValues.some(value => value !== "-" && value.toString().toLowerCase().includes(lower));
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    const filteredReportData = filterReportData(reportData, searchText);
    const groupedRows = groupReportData(filteredReportData);

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Worker Captured Audit Report - Plucking"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={integrationDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={integrationDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="modeID">Mode</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="modeID"
                                            id="modeID"
                                            name="modeID"
                                            value={integrationDetails.modeID}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">All</MenuItem>
                                            <MenuItem value="6">Manual</MenuItem>
                                            <MenuItem value="3">QR</MenuItem>
                                            <MenuItem value="1">FaceID</MenuItem>

                                        </Select>
                                        {errors["modeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["modeID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="divisionID">Collection Point</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={integrationDetails.divisionID}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="typeID">Type</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="typeID"
                                            id="typeID"
                                            name="typeID"
                                            value={integrationDetails.typeID}
                                            onChange={(e) => handleChange(e.target)}
                                        >
                                            <MenuItem value="0">All</MenuItem>
                                            {generateDropDownMenu(typeOptions)}
                                        </Select>
                                        {errors["typeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["typeID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={integrationDetails.fromDate}
                                            onChange={(e) => handleChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                max: currentDate
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            value={integrationDetails.toDate}
                                            onChange={(e) => handleChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, integrationDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                    <input
                                        type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                    {errors["noRecords"] && (<FormHelperText id="errNoRecords" className="text text-danger">{errors["noRecords"]}</FormHelperText>)}
                                </div>
                            </form>

                            {reportSearchDetails != null ?
                                <div className="pt-3">
                                    <Box display="flex" flexDirection="row-reverse" p={2}>
                                        <TextField
                                            size="small"
                                            style={{ width: '300px' }}
                                            value={searchText}
                                            placeholder="Search"
                                            onChange={(e) => setSearchText(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>
                                    <div style={{ width: '1400px' }}>
                                        <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                            <Table id="summaryReportFull" size="small" aria-label="plucking collection table full" style={{ borderCollapse: "collapse" }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell rowSpan={2} align="center" style={{ minWidth: "80px", fontSize: "0.75rem", padding: "4px", fontWeight: "bold" }}>Date</TableCell>
                                                        <TableCell rowSpan={2} align="center" style={{ minWidth: "50px", fontSize: "0.75rem", padding: "4px", fontWeight: "bold" }}>Time</TableCell>
                                                        <TableCell rowSpan={2} align="center" style={{ minWidth: "55px", fontSize: "0.75rem", padding: "4px", fontWeight: "bold" }}>Emp No</TableCell>
                                                        <TableCell rowSpan={2} align="center" style={{ minWidth: "100px", fontSize: "0.75rem", padding: "4px", fontWeight: "bold" }}>Emp Name</TableCell>
                                                        <TableCell rowSpan={2} align="center" style={{ minWidth: "55px", fontSize: "0.75rem", padding: "4px", fontWeight: "bold" }}>Worked<br />Division</TableCell>
                                                        <TableCell rowSpan={2} align="center" style={{ minWidth: "55px", fontSize: "0.75rem", padding: "4px", fontWeight: "bold" }}>Field</TableCell>
                                                        <TableCell rowSpan={2} align="center" style={{ minWidth: "60px", fontSize: "0.75rem", padding: "4px", fontWeight: "bold" }}>Operator</TableCell>
                                                        {sessionColumns.map(session => (
                                                            <TableCell key={session.id} colSpan={3} align="center" style={{ fontSize: "0.75rem", padding: "4px", fontWeight: "bold" }}>
                                                                {session.label}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                    <TableRow>
                                                        {sessionColumns.map(session => (
                                                            captureModeColumns.map(mode => (
                                                                <TableCell key={`${session.id}-${mode.id}`} align="center" style={{ minWidth: "90px", fontSize: "0.75rem", padding: "4px", fontWeight: "bold" }}>
                                                                    {mode.label}
                                                                </TableCell>
                                                            ))
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {groupedRows.length > 0 ? groupedRows.map((rowGroup, groupIndex) => {
                                                        const firstRow = rowGroup[0];
                                                        return (
                                                            <TableRow key={groupIndex}>
                                                                <TableCell align="left" >{getRowDate(firstRow)}</TableCell>
                                                                <TableCell align="left" >{getRowTime(firstRow)}</TableCell>
                                                                <TableCell align="left" >{getDisplayValue(firstRow, ["empNo", "employeeNumber", "registrationNumber", "empCode"])}</TableCell>
                                                                <TableCell align="left" >{getDisplayValue(firstRow, ["empName", "employeeName", "firstName", "name"])}</TableCell>
                                                                <TableCell align="left" >{getDisplayValue(firstRow, ["workedDivision", "workedDivisionName", "collectionPointName", "divisionName"])}</TableCell>
                                                                <TableCell align="left" >{getDisplayValue(firstRow, ["field", "fieldName", "blockName"])}</TableCell>
                                                                <TableCell align="left" >{getDisplayValue(firstRow, ["operator", "operatorName", "userName", "createdByName", "createdBy"])}</TableCell>
                                                                {sessionColumns.map(session => (
                                                                    captureModeColumns.map(mode => {
                                                                        const entries = rowGroup
                                                                            .map(row => getSessionCaptureValue(row, session, mode))
                                                                            .filter(v => v !== null);
                                                                        return (
                                                                            <TableCell key={`${session.id}-${mode.id}`} align="center"
                                                                                style={{ minWidth: "90px", padding: "4px 6px" }}>
                                                                                {entries.length > 0 ? (
                                                                                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                                                        {entries.map((entry, i) => (
                                                                                            <div key={i} style={{
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                justifyContent: "space-between",
                                                                                                gap: "4px",
                                                                                                borderBottom: i < entries.length - 1 ? "1px dashed #ccc" : "none",
                                                                                                paddingBottom: i < entries.length - 1 ? "4px" : "0"
                                                                                            }}>
                                                                                                <span style={{ fontWeight: 500, fontSize: "0.82rem", whiteSpace: "nowrap" }}>
                                                                                                    {entry.kg}
                                                                                                </span>
                                                                                                {entry.narration ? (
                                                                                                    <span style={{
                                                                                                        fontSize: "0.65rem",
                                                                                                        fontWeight: 700,
                                                                                                        padding: "1px 5px",
                                                                                                        borderRadius: "10px",
                                                                                                        whiteSpace: "nowrap",
                                                                                                        background:
                                                                                                            entry.narration.toUpperCase() === "GENERAL" ? "#e3f2fd" :
                                                                                                                entry.narration.toUpperCase() === "KILO" ? "#f3e5f5" :
                                                                                                                    entry.narration.toUpperCase() === "RSM" ? "#e8f5e9" :
                                                                                                                        entry.narration.toUpperCase() === "CASH" ? "#fff8e1" : "#f5f5f5",
                                                                                                        color:
                                                                                                            entry.narration.toUpperCase() === "GENERAL" ? "#1565c0" :
                                                                                                                entry.narration.toUpperCase() === "KILO" ? "#6a1b9a" :
                                                                                                                    entry.narration.toUpperCase() === "RSM" ? "#2e7d32" :
                                                                                                                        entry.narration.toUpperCase() === "CASH" ? "#e65100" : "#555",
                                                                                                        border: "1px solid currentColor"
                                                                                                    }}>
                                                                                                        {entry.narration.toUpperCase()}
                                                                                                    </span>
                                                                                                ) : null}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                ) : ""}
                                                                            </TableCell>
                                                                        );
                                                                    })
                                                                ))}
                                                            </TableRow>
                                                        );
                                                    }) :
                                                        <TableRow>
                                                            <TableCell colSpan={16} align="center" >No records found</TableCell>
                                                        </TableRow>
                                                    }
                                                    {filteredReportData.length > 0 ?
                                                        <TableRow>
                                                            <TableCell colSpan={7} align="center" style={{ fontWeight: "bold" }}>
                                                                Capturing Percentages
                                                            </TableCell>
                                                            {sessionColumns.map(session => (
                                                                captureModeColumns.map(mode => (
                                                                    <TableCell key={`${session.id}-${mode.id}-percentage`} align="center" style={{ fontWeight: "bold" }}>
                                                                        {getCapturePercentages(filteredReportData)[session.id][mode.id]}
                                                                    </TableCell>
                                                                ))
                                                            ))}
                                                        </TableRow>
                                                        : null}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                    <div className="pt-2">
                                        <ReactToPrint
                                            documentTitle={"Worker Capture Audit Report"}
                                            trigger={() => <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="Create PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                        <ReactHTMLTableToExcel
                                            id="test-table-xls-button"
                                            className="btn btn-primary pull-right ml-2"
                                            table="summaryReportFull"
                                            filename="Worker Capture Audit Report"
                                            sheet="tablexls"
                                            buttonText="Download as Excel"
                                        />
                                        <div hidden={true}>
                                            <CreatePdf
                                                ref={componentRef}
                                                reportData={reportData}
                                                searchData={reportSearchDetails}
                                            />
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.description}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}